import React from 'react';
import { StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { checkField, checkNothing } from '../actions';
import fields_names_strings from '../../Fields/fields_names_strings';
import ListSectionItem from '../../../design/components/ListSectionItem';
import { Text, TouchableNative } from '../../../design/components';
import { designConstants } from '../../../design/styles';
import { getSeverityColor } from '../../../shared/utilities/colorutils';
import strings from '../strings';
import Button from '../../../design/components/Button';
import { isNothingNamedField } from '../../Fields/constants';
import sharedStrings from '../../../shared/strings';
import { withTheme } from '../../../design/styles/useThemeContext';

class FactorsListSectionContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: [],
      alleviating: [],
      ineffective: [],
      initiated: false,
      initialChecked: [],
    };
  }

  componentDidMount() {
    this.initialize(this.props);
  }

  getHiddenFieldsCount(nextProps) {
    let fields = nextProps.fields.filter((field) => !!field && !!field.name);
    fields = fields.filter(
      (field) => field && !field.deleted && !field.medication,
    );
    fields = fields.filter((field) => !field.show);
    return fields.length;
  }

  shouldComponentUpdate(nextProps, nextState) {
    // The component should be updated only if checked values are changed for this field
    // But if any checkbox was checked - length will bne changed, thus we don't need
    // To compare array's items, length is sufficient

    return (
      this.props.alleviating !== nextProps.alleviating ||
      this.props.ineffective !== nextProps.ineffective ||
      !this.state.initiated ||
      nextProps.fields !== this.props.fields
    );
  }

  initialize = (props) => {
    if (this.props.fields) {
      let initialChecked = [...props.alleviating, ...props.ineffective];
      const nothingField = this.props.fields.find((field) =>
        isNothingNamedField(field?.name),
      );

      this.setState({
        fields: this.mapFields(props),
        alleviating: props.alleviating,
        ineffective: props.ineffective,
        nothingFieldId: nothingField ? nothingField.id : -1,
        initialChecked,
        initiated: true,
        hiddenFieldsCount: this.getHiddenFieldsCount(this.props),
      });
    } else {
      this.setState({
        fields: [],
        alleviating: [],
        ineffective: [],
        initialChecked: [],
        initiated: true,
        hiddenFieldsCount: 0,
        nothingFieldId: -1,
      });
    }
  };

  mapFields = (nextProps) => {
    let fields = nextProps.fields
      .filter((f) => !!f && !f.medication && !!f.name)
      .sort((a, b) => {
        if (isNothingNamedField(a.name)) {
          return -1;
        }
        if (isNothingNamedField(b.name)) {
          return 1;
        }

        let aName = a.name;
        let bName = b.name;
        return a.position !== b.position
          ? b.position - a.position
          : a.show !== b.show
            ? a.show
              ? -1
              : 1
            : (
                (a.systemDefault && fields_names_strings[aName]) ||
                aName
              ).localeCompare(
                (b.systemDefault && fields_names_strings[bName]) || bName,
              );
      });

    fields = fields.filter((field) => field && !field.deleted);
    fields = fields.map((field) => {
      return {
        ...field,
      };
    });
    fields = fields.filter(
      (field) => field.show || this.state.initialChecked.includes(field.id),
    );
    return fields;
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.fields !== this.props.fields ||
      nextProps.alleviating !== this.props.alleviating ||
      nextProps.ineffective !== this.props.ineffective
    ) {
      this.setState({
        fields: this.mapFields(nextProps),
        alleviating: nextProps.alleviating,
        ineffective: nextProps.ineffective,
        hiddenFieldsCount: this.getHiddenFieldsCount(nextProps),
      });
    }
  }

  checkField = (fieldType, fieldId, isNothingNamed) => {
    const alleviatingChecked = this.state.alleviating.includes(fieldId);
    const ineffectiveChecked = this.state.ineffective.includes(fieldId);
    let alleviating = this.state.alleviating;
    let ineffective = this.state.ineffective;

    if (isNothingNamed) {
      const checkedField = alleviating.includes(fieldId);
      this.props.dispatch(
        checkNothing('alleviating_factor', fieldId, !checkedField),
      );
      this.setState({
        alleviating: checkedField ? [] : [this.state.nothingFieldId],
        ineffective: [],
      });
      return;
    }

    if (alleviatingChecked) {
      if (!fieldType) {
        alleviating = alleviating.slice();
        alleviating.splice(alleviating.indexOf(fieldId), 1);
        this.props.dispatch(checkField('alleviating_factor', fieldId, false));
      } else if (fieldType !== 'alleviating') {
        alleviating = alleviating.slice();
        alleviating.splice(alleviating.indexOf(fieldId), 1);
        this.props.dispatch(checkField('alleviating_factor', fieldId, false));
        ineffective = ineffective.slice();
        ineffective.push(fieldId);
        this.props.dispatch(checkField('ineffective_factor', fieldId, true));
      }
    } else if (ineffectiveChecked) {
      if (!fieldType) {
        ineffective = ineffective.slice();
        ineffective.splice(ineffective.indexOf(fieldId), 1);
        this.props.dispatch(checkField('ineffective_factor', fieldId, false));
      } else if (fieldType !== 'ineffective') {
        ineffective = ineffective.slice();
        ineffective.splice(ineffective.indexOf(fieldId), 1);
        this.props.dispatch(checkField('ineffective_factor', fieldId, false));
        alleviating = alleviating.slice();
        alleviating.push(fieldId);
        this.props.dispatch(checkField('alleviating_factor', fieldId, true));
      }
    } else {
      //Not checked anything, need to check
      const nothingFieldId = this.state.nothingFieldId;

      if (fieldType === 'alleviating' || !fieldType) {
        alleviating = alleviating.slice();
        alleviating.push(fieldId);

        this.props.dispatch(checkField('alleviating_factor', fieldId, true));
      } else if (fieldType === 'ineffective') {
        ineffective = ineffective.slice();
        ineffective.push(fieldId);
        this.props.dispatch(checkField('ineffective_factor', fieldId, true));
      }
      if (nothingFieldId >= 0 && alleviating.includes(nothingFieldId)) {
        alleviating.splice(alleviating.indexOf(nothingFieldId), 1);
      }
      if (nothingFieldId >= 0 && ineffective.includes(nothingFieldId)) {
        ineffective.splice(ineffective.indexOf(nothingFieldId), 1);
      }
    }

    this.setState({ alleviating, ineffective });
  };

  renderRow = (rowData) => {
    const fieldId = rowData.id;
    let name =
      (rowData.systemDefault && fields_names_strings[rowData.name]) ||
      rowData.name;
    let checkedFactor = this.props.alleviating?.includes(fieldId)
      ? 'alleviating'
      : this.props.ineffective?.includes(fieldId)
        ? 'ineffective'
        : null;
    const nothingNamed = isNothingNamedField(rowData.name);
    const { colors } = this.props.theme;
    const isNothingNamedChecked =
      this.state.nothingFieldId >= 0 &&
      this.props.alleviating.includes(this.state.nothingFieldId);

    return (
      <ListSectionItem
        style={{ marginHorizontal: 15 }}
        label={name}
        secondaryLabel={
          nothingNamed &&
          sharedStrings.list_section_content_nothing_item_subtitle
        }
        disabled={isNothingNamedChecked && !nothingNamed}
        checked={!!checkedFactor}
        mmpicon={rowData.icon_code}
        checkbox
        key={rowData.id}
        onPress={() => this.checkField(null, fieldId, nothingNamed)}
      >
        {!nothingNamed && (
          <>
            <View>
              <Text small>{strings.factors_section_type_header}</Text>
              <View
                style={[
                  styles.sectionButtonsContainer,
                  { backgroundColor: colors.defaultWindowBg },
                ]}
              >
                <TouchableNative
                  onPress={() => this.checkField('alleviating', fieldId)}
                  style={[
                    styles.sectionButton,
                    {
                      backgroundColor:
                        checkedFactor === 'alleviating'
                          ? getSeverityColor(0)
                          : colors.defaultWindowBg,
                    },
                  ]}
                >
                  <Text
                    medium
                    white
                    style={[
                      checkedFactor !== 'alleviating' && {
                        color: colors.textSecondary,
                      },
                      { textAlign: 'center' },
                    ]}
                  >
                    {strings.factors_section_alleviating_button}
                  </Text>
                </TouchableNative>
                <TouchableNative
                  onPress={() => this.checkField('ineffective', fieldId)}
                  style={[
                    styles.sectionButton,
                    {
                      backgroundColor:
                        checkedFactor === 'ineffective'
                          ? getSeverityColor(5)
                          : colors.defaultWindowBg,
                    },
                  ]}
                >
                  <Text
                    medium
                    white
                    style={[
                      checkedFactor !== 'ineffective' && {
                        color: colors.textSecondary,
                      },
                    ]}
                  >
                    {strings.factors_section_ineffective_button}
                  </Text>
                </TouchableNative>
                {false && ( //Right now, disable "aggravating" for factors, will turn on later
                  <TouchableNative
                    onPress={() => this.checkField('aggravating', fieldId)}
                    style={{
                      flexDirection: 'row',
                      height: 44,
                      alignSelf: 'stretch',
                    }}
                  >
                    <Text medium white>
                      {strings.factors_section_aggravating_button}
                    </Text>
                  </TouchableNative>
                )}
              </View>
            </View>
          </>
        )}
      </ListSectionItem>
    );
  };

  editList = () => {
    this.props.navigation.navigate('common', {
      screen: 'editList',
      params: { field: 'alleviating_factor' },
    });
  };

  render() {
    if (!this.state.fields) {
      return null;
    }
    return (
      <View>
        {this.state.fields.map(this.renderRow)}
        <View style={styles.footerContainer}>
          {!!this.state.hiddenFieldsCount && (
            <Text
              medium
              lightGray
              numberOfLines={2}
              style={{
                alignSelf: 'stretch',
                textAlign: 'center',
                marginBottom: 12,
              }}
            >
              {strings.formatString(
                sharedStrings.list_section_content_additional_values_can_be_shown,
                this.state.hiddenFieldsCount,
              )}
            </Text>
          )}
          <Button
            tag={'edit_list_factors'}
            outlined
            style={{
              alignSelf: 'stretch',
            }}
            onPress={this.editList}
            text={sharedStrings.list_section_content_add_new_edit_list_button}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    height: 48,
    paddingLeft: designConstants.paddings.edgePadding,
    paddingRight: designConstants.paddings.edgePadding,
  },
  sectionButtonsContainer: {
    flexDirection: 'row',
    height: 44,
    alignSelf: 'stretch',
    borderRadius: 4,
    marginTop: 6,
  },
  sectionButton: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    margin: 4,
    borderRadius: 4,
  },
  footerContainer: {
    flexDirection: 'column',
    marginHorizontal: designConstants.paddings.edgePadding,
    marginTop: designConstants.paddings.textFieldVerticalPadding,
    marginBottom: designConstants.paddings.edgePadding,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const mapStateToProps = (state, ownProps) => {
  //return a copy of each field, so not change field directly

  let alleviating =
    state.records.current?.record?.fields?.alleviating_factor || [];
  let ineffective =
    state.records.current?.record?.fields?.ineffective_factor || [];

  return {
    fields: state.fields.alleviating_factor,
    factors: state.fields,
    alleviating,
    ineffective,
  };
};

export default connect(mapStateToProps)(withTheme(FactorsListSectionContent));
